import React, { useEffect, useState } from "react";
import axios from "axios";
// import borderImg from "../../src/Assets/Vector 5.png";

const Footer = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  // 🔹 API CALL
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(
          "https://mediapi.onlinepharmaque.in/api/v1/getallcategory"
        );

        setCategories(res.data.category || []);
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  return (
   <footer className="relative text-[#A4A5A8] bg-[#f5f7f9]">

      {/* 🔹 TOP BORDER IMAGE */}
      {/* <img
        src={borderImg}
        alt="footer border"
        className="w-full object-cover"
      /> */}

      {/* 🔹 FOOTER */}
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-12">

            {/* Company */}
            <div>
              <h4 className="text-[#187685] font-bold text-[16px] mb-6">
                Company
              </h4>
              <ul className="space-y-3 text-[16px]">
                <li>About us</li>
                <li>Careers</li>
                <li>Blog</li>
              </ul>
            </div>

            {/* Our Services */}
            <div>
              <h4 className="text-[#187685] font-bold text-[16px] mb-6">
                Our Services
              </h4>
              <ul className="space-y-3 text-[16px]">
                <li>Health Insurance</li>
                <li>Life Insurance</li>
                <li>Personal Insurance</li>
                <li>Term Insurance</li>
              </ul>
            </div>

            {/* ✅ Featured Categories (Dynamic) */}
            <div>
              <h4 className="text-[#187685] font-bold text-[16px] mb-6">
                Featured Categories
              </h4>

              <ul className="space-y-3 text-[16px] leading-relaxed">
                {loading ? (
                  <li>Loading...</li>
                ) : categories.length > 0 ? (
                  categories.map((item) => (
                    <li key={item._id}>
                      {item.MaincategoryName}
                    </li>
                  ))
                ) : (
                  <li>No Categories Found</li>
                )}
              </ul>
            </div>

            {/* Policy Info */}
            <div>
              <h4 className="text-[#187685] font-bold text-[16px] mb-6">
                Policy Info
              </h4>
              <ul className="space-y-3 text-[16px]">
                <li>Editorial Policy</li>
                <li>Privacy Policy</li>
                <li>Terms and Conditions</li>
                <li>Customer Support Policy</li>
                <li>Return Policy</li>
              </ul>
            </div>

            {/* Newsletter */}
            <div>
              <h4 className="text-[#187685] font-bold text-[16px] mb-6">
                Join a Newsletter
              </h4>

              <label className="block mb-2 text-[16px]">
                Your Email
              </label>

              <div className="flex flex-col sm:flex-row gap-3 mb-6">
                <input
                  type="email"
                  placeholder="Enter Your Email"
                  className="w-full px-4 py-3 border border-[#187685] text-black outline-none"
                />
                <button className="bg-[#187685] text-white px-8 py-3 font-semibold rounded-md">
                  Subscribe
                </button>
              </div>

              <div className="flex gap-4">
                {["Dr", "Be", "Ig"].map((item) => (
                  <div
                    key={item}
                    className="w-10 h-10 bg-[#187685] text-white rounded-full 
                               flex items-center justify-center font-bold"
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
